import React, { Component } from 'react';
import LoaderWrapper from '../../../../Components-2025/QuestionBank/LoaderWrapper';
import ReadingList from '../../../../Components-2025/QuestionBank/ReadingList';
import ComponentHeader from '../../../../common/ComponentHeader';
import CustomButton from '../../../../common/CustomButton';
import { messages } from '../../../../common/messages';
import { showInformation } from '../../../../common/toast';
import ModalComponent from '../../../Common/Modal';
import PDFModelComponent from '../../../Common/PDFModel';
import config from '../../../config/AppRoutes';
import { nextAwareRoute } from '../../../../common/cfa1NextRoutes';
import { chapterNameKey, chapterOrderKey, freeQuestionCountKey } from './ApiAttributesKeys';
import apiServiceProvider from './ApiService';

/* eslint-disable*/

export default class ReadingsList extends Component {
  static contextTypes = { router: React.PropTypes.object };
  constructor(props) {
    super(props);
    this.state = {
      selectedExamSubscriptionDetails: {},
      chapterName: '',
      chapterOrder: 0,
      isPopupOpen: false,
      isPremiumPopupOpen: false,
      isUserSubscribed: false,
      readingListData: [],
      isLoading: true,
    };
  }

  async componentDidMount() {
    const { chapterId } = this.props.params;
    const readingListData = await apiServiceProvider['fetchReadingList']({ chapterId });
    if (readingListData.success) {
      const { readings, selectedExamSubscriptionDetails } = readingListData;
      if (selectedExamSubscriptionDetails.level1SubscriptionDetails) {
        this.setState({ isUserSubscribed: true });
      }
      this.setState({
        readingListData: readings,
        selectedExamSubscriptionDetails,
        isLoading: false,
        chapterName: readingListData.chapterName[chapterNameKey],
        chapterOrder: readingListData.chapterName[chapterOrderKey],
      });
    }
    this.setState({ isLoading: false });
  }
  checkSubscription = async (cb, type) => {
    const { isUserSubscribed } = this.state;
    if (!isUserSubscribed) {
      return this.setState({ isPremiumPopupOpen: true });
    }
    // Only show the "export initiated" success modal when the API accepted the
    // request. An ungenerated PDF returns { success:false, status:404 }; showing
    // the success modal regardless falsely told the user an email was on the way.
    const response = await cb();
    if (response && response.success) {
      this.setState({ PDFDownloadType: type });
      this.pdfAlertModel();
    } else {
      showInformation(
        (response && response.message) || messages.PDF_DOWNLOAD_NOT_AVAILABLE,
      );
    }
  };

  onHandleRedirectTOSubscription = () => {
    const { router } = this.context;
    router.push({ pathname: '/Subscribe' });
  };

  toggleAlert = () => {
    this.setState({ isPremiumPopupOpen: !this.state.isPremiumPopupOpen });
  };

  pdfAlertModel = () => {
    this.setState({ isPopupOpen: !this.state.isPopupOpen });
  };

  onViewList = items => {
    const { isUserSubscribed } = this.state;
    if(items.totalQuestion){
      if (!isUserSubscribed ) {
        if (items[freeQuestionCountKey] === 0) {
          showInformation(messages.QUESTION_NOT_AVAILABLE_FOR_READING);
        }else if(items[freeQuestionCountKey] !== 0){
          const { router } = this.context;
           router.push({
          pathname: nextAwareRoute(config.CFA1_2025_QUESTIONS_LIST).replace(':readingId', items.id),
          });
        }else{
          return this.setState({ isPremiumPopupOpen: true });
        }
      } else {
        const { router } = this.context;
        router.push({
          pathname: nextAwareRoute(config.CFA1_2025_QUESTIONS_LIST).replace(':readingId', items.id),
        });
      }
    }else{
      showInformation(messages.QUESTION_NOT_AVAILABLE_FOR_READING);
    }
  };

  onBeginChapter = items => {
    const { isUserSubscribed } = this.state;
    if(items.totalQuestion){
      if (!isUserSubscribed) {
        if (items[freeQuestionCountKey] === 0) {
          showInformation(messages.QUESTION_NOT_AVAILABLE_FOR_READING);
        }else if(items[freeQuestionCountKey] !== 0){
          const { router } = this.context;
           router.push({
          pathname: nextAwareRoute(config.CFA1_2025_QUESTIONS_LIST).replace(':readingId', items.id),
           });
        }
        else{
          return this.setState({ isPremiumPopupOpen: true });
        }
      } else {
        const { router } = this.context;
        router.push({
          pathname: nextAwareRoute(config.CFA1_2025_QUESTION_VIEW).replace(':readingId', items.id),
        });
      }
    }else{
      showInformation(messages.QUESTION_NOT_AVAILABLE_FOR_READING);
    }
  };

  render() {
    const { params } = this.props;
    const { chapterId } = params;
    const {
      chapterName,
      chapterOrder,
      isPopupOpen,
      isPremiumPopupOpen,
      isUserSubscribed,
      readingListData,
      isLoading = false,
    } = this.state;
    const { router } = this.context;

    return (
      <div className='animated fadeIn'>
        {/* //* ============================{{ HEADER START HERE }}========================================== */}
        <ComponentHeader title={`${chapterOrder !== 0 ? `${chapterOrder}.` : ''} ${chapterName}`}>
          <div>
            <CustomButton
              className='bg-completed-cases overflow-hidden max-width-min-content'
              onClick={() => {
                this.checkSubscription(
                  () =>
                    apiServiceProvider['pdfDownloadViaEmail']({
                      pdfType: 'question',
                      chapterId,
                    }),
                  'Question',
                );
              }}
            >
              <i className='fa fa-download pr-1' aria-hidden='true' />
              {!isUserSubscribed && <div className='premium-download'>Premium</div>}
              {messages.DOWNLOAD_QUESTION}
            </CustomButton>
            <CustomButton
              className='bg-completed-cases overflow-hidden max-width-min-content'
              onClick={() => {
                this.checkSubscription(
                  () =>
                    apiServiceProvider['pdfDownloadViaEmail']({
                      pdfType: 'questionAnswer',
                      chapterId,
                    }),
                  'Question/Answer',
                );
              }}
            >
              <i className='fa fa-download pr-1' aria-hidden='true' />
              {!isUserSubscribed && <div className='premium-download'>Premium</div>}
              {messages.DOWNLOAD_QUESTION_ANSWER}
            </CustomButton>
            <CustomButton onClick={() => router.push({ pathname: nextAwareRoute(config.CFA1_2025_QUESTION_BANK) })}>
              {messages.CHANGE_TOPIC}
            </CustomButton>
          </div>
        </ComponentHeader>
        {/* //* ============================{{ HEADER ENDED HERE }}========================================== */}
        <LoaderWrapper isLoading={isLoading}>
          <ReadingList
            readingData={readingListData}
            tableName={messages.CHAPTER_READING}
            onViewList={this.onViewList}
            onBeginChapter={this.onBeginChapter}
          />
        </LoaderWrapper>
        {/* //* THIS IS FOR PREMIUM POPUP  */}
        <ModalComponent
          goPremium={this.onHandleRedirectTOSubscription}
          toggleAlert={this.toggleAlert}
          alert_status={isPremiumPopupOpen}
          MessageContent={messages.CFA1_2025_PREMIUM_POPUP}
          exam={'cfa'}
        />

        {/* //* THIS IS PDF DOWNLOAD SUCCESS MODAL POP-UP  */}
        <PDFModelComponent
          type={'Question'}
          pdfAlertModel={this.pdfAlertModel}
          pdfAlert={isPopupOpen}
          PDFContentMessage={messages.PDF_DOWNLOAD_CONTENT_MESSAGE}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/CFA1-2025/QuestionBank/QuestionReadingList/ReadingsList.jsx